var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[(_vm.toggleSidebar)?_c('sidebar',{staticClass:"main-sidebar"}):_vm._e(),_c('v-app',[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }